import { render, staticRenderFns } from "./EmailGroups.vue?vue&type=template&id=5645f584&"
import script from "./EmailGroups.vue?vue&type=script&lang=js&"
export * from "./EmailGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports